import AdvanceReceiptService from './AdvanceReceiptService'
import StoreUtil from '@/store/utils'
// import DeepDiff from 'deep-diff'
// import { md5 } from '@/components/crypto'
// import _cloneDeep from 'lodash/cloneDeep'

const tag = 'advancereceipt'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  readOnlyView: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  readOnlyView: state => state.readOnlyView
}

const actions = {
  async getStoreItem({ commit }, id) {
    // let entity = await AdvanceReceiptService.getEntity(id)
    // entity.invoiceDate = entity.invoiceDate.split('.')[1] ? entity.invoiceDate.split('.')[0] + 'Z' : entity.invoiceDate
    // commit('saveInitialSnapshots', entity)
    // return entity
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity || (entity && !entity.isNew)) {
      const hash = entity ? md5(JSON.stringify(entity)) : ''
      const data = await AdvanceReceiptService.getEntity(id, hash)
      if (data) {
        console.log('from WebApi')
        data.invoiceDate = data.invoiceDate.split('.')[1] ? data.invoiceDate.split('.')[0] + 'Z' : data.invoiceDate
        data.payDate = data.payDate.split('.')[1] ? data.payDate.split('.')[0] + 'Z' : data.payDate
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.invoiceId, tag, entity)
    commit('saveInitialSnapshots', entity)

  },
  async editStoreItem({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await AdvanceReceiptService.getEntity(id, ''))
    //const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    //entity.payDate = utcDate.split('.')[0] + 'Z'
    StoreUtil.setStorage(entity.invoiceId, tag, entity)
    commit('saveInitialSnapshots', entity)
    //router.push({ path: `advancereceipts/${id}`})
    //StoreUtil.routeToDetail(FactorInvoiceRoutes.FactorInvoiceDetail.path, entity.invoiceId, false)
  },
  async editStoreItemByInvoiceId({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await AdvanceReceiptService.getEntityByInvoiceId(id, ''))
    StoreUtil.setStorage(entity.invoiceId, tag, entity)
    commit('saveInitialSnapshots', entity)
    //router.push({ path: `advancereceipts/${id}`})
    //StoreUtil.routeToDetail(FactorInvoiceRoutes.FactorInvoiceDetail.path, entity.invoiceId, false)
  },
  async addStoreItem({ commit }, id) {
    const entity = await AdvanceReceiptService.getNewEntity()
    const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    entity.invoiceDate = utcDate.split('.')[0] + 'Z'
    entity.payDate = utcDate.split('.')[0] + 'Z'
    StoreUtil.setStorage(id, tag, entity)
    commit('saveInitialSnapshots', entity)
    return entity
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setReadOnlyView({ commit }, value) {
    commit('setReadOnlyView', value)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  setReadOnlyView(state, value) {
    state.readOnlyView = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
